import { TrackJsConfigService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { trackJsConfig } from '../models';

export const provideTrackJsConfigService = (): (() => TrackJsConfigService) => {
  return () => {
    return new TrackJsConfigService(trackJsConfig);
  };
};
